import pagination from './pagination/pagination.vue'
import noData from './no_data/index.vue'
import selectOption from './select_option/option.vue'
import checkboxOption from './select_option/checkbox.vue'
import uploadImg from './upload_img/uploadimg'
import cropperImg from './upload_img/cropperImg'
import uploadFile from './upload_img/uploadfile'
import uploadfileqt from './upload_img/uploadfileqt'
import richEditor from './editor/editor.vue'
import backToTop from './back_to_top/index.vue'
import canlendar from './calendar'
import timeSelect from './time_period/time_select.vue'
import timeBlock from './time_period/time_block.vue'
import weekPeriod from './time_period/week_period.vue'
import treeSelect from './tree_select/index.vue'
import classifyitem from './classify-item/index.vue'
import sortby from './sortby/index.vue'

export default {
    'pagination': pagination,
    'nodata': noData,
    'option': selectOption,
    'checkbox': checkboxOption,
    'uploadimg': uploadImg,
    'cropper': cropperImg,
    'uploadfile': uploadFile,
    'uploadfileqt':uploadfileqt,
    'richeditor': richEditor,
    'backtotop': backToTop,
    'canlendar': canlendar,
    'timeSelect': timeSelect,
    'timeBlock': timeBlock,
    'weekPeriod': weekPeriod,
    'treeselect': treeSelect,
    'classifyitem':classifyitem,
    'sortby':sortby
}



// WEBPACK FOOTER //
// ./src/components/index.js